import {React,useState,useContext,useReducer,useEffect} from 'react'
import { useNavigate,Link } from 'react-router-dom';
import {conitem} from '../context/Contextitem'
import { categoriesurl} from '../component/Fetcher';



const initaistate ={
 
    loading : true,
    data : [],
    error : '',

}


const reducer = (state,action)=>{
  
  switch(action.type){
    case 'sucess' :
      return{...state,
        loading: false ,
        data: action.payload,
        error: ''
      }
 case 'error' :
    return{...state,
      loading: false ,
      data: [],
      error: action.errormessage
    }
  }
}


const Headersm = () => {

  const navigate = useNavigate()

   const[ count , dispatch] = useReducer(reducer,initaistate)
  const [dropdown, setdropdown]= useState(false)

     const { basketiconvalue} = useContext(conitem)


        useEffect(()=>{
           
            categoriesurl({dispatch})
             
          },[])
          
        const rerender = ()=>{
          return count.data.map(data=>(
          
          <p key={data.id}><Link style={{color:'white',textDecoration:'none'}} to={`/categories/${data.id}`}>{data.title}</Link></p>
           
          ))
        }

  return (
    <>
    <div id='sm-wrapper'>
<div id='logo-container'>
<img onClick={()=>navigate('/')} src="/asset/logo1project.jpg" alt=""  />
</div>

<div  id='menu-container'>
  <div>
<img  onClick={()=>setdropdown(prev=>!prev)} src="/asset/menu.svg" alt=""  />

  </div>

<div onClick={()=>navigate('/basket')} id='cart'>
  <img src="/asset/icon-cart.svg" alt=""  />
  <p>{basketiconvalue}</p>
</div>
</div>
    </div>
{
  dropdown? <div id='categories-drop-down'>
      <h5>Categories</h5>
      
  {rerender()}
<p>Groceries</p>
<p>Premiun Fruits</p>

       <hr />

       <div id='sign-in-wrapper'>
        <img src="asset/icon-user.svg" alt="" srcset="" />
        <p onClick={()=>navigate('/Login')}>Login</p>
       </div>
    </div> : ''
}
   
    </>
  )
}

export default Headersm